// Module
var code = `<div class="row">
    <div class="col-md-12">
        <table class="table">
            <tr>
                <th>User
                    <a ng-click="create_user()" class="btn btn-success btn-xs">Create</a>
                </th>
                <th>Activate</th>

                <th>Permissions</th>
                <th>
                    Actions

                </th>
            </tr>
            <tr ng-repeat="(user_email, user) in user_items">
                <td style="width: 10%; min-width: 100px;">
                    {{user.email}}
                </td>
                <td style="width: 10%; min-width: 150px;">
                    <a ng-click="toggle_activate_user(user.id)" ng-if="!user.is_active" class="btn btn-warning btn-xs">active</a>
                    <a ng-click="toggle_activate_user(user.id)" ng-if="user.is_active" class="btn btn-success btn-xs">active</a>
                    <a ng-click="toggle_admin_user(user.id)" ng-if="user.is_active && !user.is_admin" class="btn btn-warning btn-xs">admin</a>
                    <a ng-click="toggle_admin_user(user.id)" ng-if="user.is_active && user.is_admin" class="btn btn-success btn-xs">admin</a>
                </td>
                <td style="width: 60%;">
                    <span class="label label-info" ng-if="user.is_active && user.is_admin">All</span>
                    <span class="label label-info" ng-if="user.is_active && !user.is_admin"
                          ng-repeat="role in user.roles.roles" style="margin-right: 2px;">{{role}} </span>
                    <a ng-if="user.is_active  && !user.is_admin"
                       ng-click="open_modal_form('users_manager.UpdateUserRolesForm', user.id)"
                       class="btn btn-primary btn-xs">
                        Edit
                    </a>
                </td>
                <td style="width: 20%; min-width: 200px;">
                    <a ng-click="open_modal_form('users_manager.UpdateUserPasswordForm', user.id)" class="btn btn-warning btn-xs">
                        Set Password
                    </a>
                    <a ng-click="delete_user(user.id)" class="btn btn-danger btn-xs">
                        Delete
                    </a>
                </td>
            </tr>
        </table>
    </div>
</div>`;
// Exports
module.exports = code;